var e=(e,i)=>[e.slice(0,i).join(""),e.slice(i).join("")].join(".");export{e as getCurrentReadingValue};
//# sourceMappingURL=getCurrentReadingValue.js.map